import { styled } from '@mui/material/styles';

export const DateField = styled('div')({
  width: 180,
  '& > div': { width: '100%' },
});
